<template>
    <div class="b1t-okraina-catalog-sections">

        <div class="container">
            <div class="row items">
                <div class="col-6 item-wrapper" v-for="item in items" :key="item.ID">
                    <router-link class="item" :to="{name: 'catalog-section', params: {id: item.ID}}">
                        <div class="picture" :style="{ backgroundImage: 'url('+item.PICTURE.SRC+')' }"></div>
                        <div class="name">{{item.NAME}}</div>
                    </router-link>
                </div>
            </div>

            <div class="btn-wrapper" v-if="this.show_count > 0">
                <router-link class="btn-more" :to="{name: 'catalog'}">
                    Ещё <span class="icon b1t-fi b1t-fi b1t-fi-arrow-right"></span>
                </router-link>    
            </div>
        </div>

        
    </div>
</template>

<script>
    import axios from 'axios';
    import objectToFormData from '../../../plugins/object-to-form-data'

    export default {
        name: 'b1t-okraina-catalog-sections',
        props: {
            show_count: {
                type: Number,
                default() {
                    return 0;
                }
            },
            parent: {
                type: String,
                default() {
                    return "";
                }
            },
            drop_page_loading: {
                type: Boolean,
                default(){
                    return false;
                }
            }
        },
        data() {
            return {
                items: [
                   
                ],
            }
        },
        methods: {
            load() {

                let arParams = {
                    "ORDER": {
                        "NAME":"ASC"
                    },
                    "FILTER": {
                    },
                    "RESIZE_OPTIONS": {
                        "WIDTH":"200",
                        "HEIGHT":"200",
                        "TYPE":"EXACT"
                    }
                };

                if(this.parent !== "") {
                    arParams.FILTER["SECTION_ID"] = this.parent;
                } else {
                    arParams.FILTER["DEPTH_LEVEL"] = 1;
                }

                return axios(this.$store.state.apiUrl + '/rest/catalog.sections.getlist', {
                    method: "POST",
                    data: objectToFormData(arParams),
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
                    }
                }).then((response) => {

                    if(this.show_count > 0 && response.data.ITEMS.length > this.show_count) {
                        response.data.ITEMS = response.data.ITEMS.slice(0,this.show_count);
                    }

                    this.items = response.data.ITEMS;
                    
                    return response;
                }).catch((error) => {
                    return error;
                })
            },

        },
        mounted(){
            this.load()
            .then(() => {
                if(this.drop_page_loading) {
                    this.$store.dispatch('SET_LOADING',false);
                }
                
            });
        }
    }
</script>

<style lang="scss">
    .b1t-okraina-catalog-sections {
        background: #f4f4f4;
        padding-top: 15px;

        .items {
            margin: 0px -7px;
        }

        .items > div{
            padding: 0px 7px;
        }

        .item {
            margin-bottom: 15px;
            display:block;
            border-bottom: 0px;
            position: relative;

            .picture {
                height: 0px;
                padding-top: 100%;

                background-size: cover;
            }

            .name {
                position: absolute;
                bottom: 0px;
                left: 0px;
                right: 0px;
                text-align: center;
                color: #fff;
                font-size: 17px;
                line-height: 1.2;

                padding: 7px;
                background: #76B82B;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 54px;
            }
        }

        .btn-wrapper {
            text-align: right;
            padding: 0px 0px 10px;
        }

        .btn-more {
            color: #76B82B;
            border-bottom: 0px;
            position: relative;
            display: inline-block;
            padding-right: 30px;
            font-size: 16px;

            .icon {
                position: absolute;
                top: 50%;
                right: 0px;
                transform: translateY(-50%);
            }
        }


    }
</style>